import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/lib/supabase";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [checkingMfa, setCheckingMfa] = useState(true);
  const [mfaBlocked, setMfaBlocked] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (!user) {
      setCheckingMfa(false);
      return;
    }

    // Verificar que el usuario haya completado el segundo factor si lo tiene habilitado
    supabase.auth.mfa.getAuthenticatorAssuranceLevel().then(({ data, error }) => {
      if (!isMounted) return;
      if (!error && data && data.currentLevel === "aal1" && data.nextLevel === "aal2") {
        setMfaBlocked(true);
      } else {
        setMfaBlocked(false);
      }
      setCheckingMfa(false);
    }).catch(() => {
      if (isMounted) setCheckingMfa(false);
    });

    return () => {
      isMounted = false;
    };
  }, [user]);

  if (loading || checkingMfa) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-legal-blue"></div>
      </div>
    );
  }

  if (!user) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }

  if (mfaBlocked) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?mfa_required=true&returnUrl=${returnUrl}`} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
